<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(item.dictValue)">
        <span
          v-if="item.elTagType == 'default' || item.elTagType == ''"
          :key="item.dictValue+''"
          :index="index"
          :class="item.elTagClass"
        >{{ i18nConfig(item.dictLabel) }}</span>
        <el-tag
          v-else
          :disable-transitions="true"
          :key="item.dictValue + ''"
          :index="index"
          :type="item.elTagType === 'primary' ? 'primary' : item.elTagType"
          :class="item.elTagClass"
        >{{ i18nConfig(item.dictLabel) }}</el-tag>
      </template>
    </template>
  </div>
</template>

<script setup>
import { i18nConfig } from '@/utils/ruoyi'
const props = defineProps({
  // 数据
  options: {
    type: Array,
    default: null,
  },
  // 当前的值
  value: [Number, String, Array],
})

const values = computed(() => {
  if (props.value !== null && typeof props.value !== 'undefined') {
    return Array.isArray(props.value) ? props.value : [String(props.value)];
  } else {
    return [];
  }
})

</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>